<template>
  <el-dialog title="Prorrogar Reserva do Imóvel" @open="reset" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Duração da Prorrogação">
            <el-select v-model="reserva.duracao" style="width: 100%">
              <el-option
                v-for="item in duracaoReserva"
                :key="item.data"
                :label="item.label"
                :value="item.data">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="prorrogarHandler" type="success" size="small" round class="btn-box-shadow">Prorrogar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { DURACAO_PRORROGACAO } from '../../../util/constantes.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      reserva: {
        duracao: 6,
      }
    }
  },
  computed: {
    ...mapState('vendasImoveisStore', {
      imovel(state) { return state.imovelSelecionado },
    }),
    duracaoReserva() { return DURACAO_PRORROGACAO }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('vendasImoveisStore', [
      'prorrogarReservaImovel'
    ]),
    reset() {
      this.reserva = {
        duracao: 6,
      }
    },
    prorrogarHandler() {
      let payload = this.reserva;
      payload.imovel = { id: this.imovel.id };

      this.showLoading();
      this.prorrogarReservaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.concluir();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    concluir() {
      this.$emit('prorrogar');
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>

